import { Divider, ScrollButtons } from 'src/shared/design-system/DishFirst/Carousel';
import styled, { css } from 'styled-components';
import { Mixins, Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
  ${Mixins.Padding.set(Spacing.NONE, Spacing.SINGLE)}
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  align-items: center;
  justify-content: flex-start;

  overflow-x: scroll;
  overflow-y: clip;
  scroll-snap-type: x mandatory;
  gap: ${Spacing.SINGLE};

  ${Mixins.Scrollbar.hide()}
  ${Mixins.Padding.setBottom(Spacing.SINGLE_HALF)}

  & > * {
    scroll-snap-align: start;
    opacity: 1;
    transition: opacity 0.11s ease-in-out;
  }

  ${Mixins.Media.maxWidthSmall(css`
    scroll-snap-type: none;
  `)}

  .offscreen {
    opacity: 0;
  }
`;

export const RowScrollButtons = styled(ScrollButtons)`
  position: absolute;
  top: 0;
  right: 0px;

  ${Mixins.Media.maxWidthMedium(css`
    display: none;
  `)}
`;

export const SegmentDivider = styled(Divider)`
  bottom: 0;
  ${Mixins.Media.minWidthMedium(css`
    display: none;
  `)}
`;
